package com.neurobs.ccab

import com.neurobs.ccab.db.{LogfileData, LogfileStorageData, TestRunData}
import com.neurobs.util.{Guid, SecondsTimestamp}
import io.circe.{Decoder, Encoder}

/**
 * The string representations of these must not change as they
 * are used as identifiers by external applications and in the
 * database.
 */
object CaasType extends Enumeration {
	val Agora = Value("Agora")
	val Opentok = Value("Opentok")

	def withNameOpt(s: String): Option[Value] = values.find(_.toString == s)
}

case class ControllerSessionData
(
	id: Long,
	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
	accountId: Long,
	userId: Long,
	caasType: CaasType.Value,
	sessionId: String,
	controllerName: String,
	controllerVersion: VersionNumber,
	computerName: String,
	requestIp: String,
	lanIp: String
)

object Sex extends Enumeration {
	val Male =        Value("M")
	val Female =      Value("F")
	val TransMale =   Value("TM")
	val TransFemale = Value("TF")
}

object KeyStorageType extends Enumeration {
	val Config = Value("config")
}

case class SessionView
(
	sessionId: Long,
	startTime: SecondsTimestamp,
	stationUserId: Long,
	adminUserId: Option[Long],
	stationName: String,
	subjectGuid: Guid,
	properties: Option[String],
	sessionLogId: Option[Long],

	accountId: Long,
	primaryEmail: String,
	organization: String,

	studyId: Long,
	studyDisplayName: String,

	studyTypeId: Long,
	studyTypeDisplayName: String,

	accountSubjectId: Long,
	encodedIdentity: Option[Array[Byte]],
	reportingId: Guid
)

case class TestRunView
(
	subjectId: Long,
	birthYear: Option[Int],
	accountSubjectId: Long,
	reportingId: Guid,
	accountId: Long,
	primaryEmail: String,
	studyId: Long,
	studyDisplayName: String,
	studyTypeId: Long,
	studyTypeDisplayName: String,
	sessionId: Long,
	subjectGuid: Guid,
	sessionProperties: Option[String],
	testId: Long,
	testDisplayName: String,
	testRunId: Long,
	startTime: SecondsTimestamp,
	runError: Option[String]
)

case class TestRunLogfileView
(
	testRun: TestRunData,
	logfileData: LogfileData
)

object DatabaseJson {
	// CaasType
	implicit val notificationTypeDecoder: Decoder[CaasType.Value] = Decoder.decodeEnumeration(CaasType)
	implicit val notificationTypeEncoder: Encoder[CaasType.Value] = Encoder.encodeEnumeration(CaasType)
}